import { prettyFormatNumber } from '@helios/utils'
import { GenericTransaction, GenericTxSummary } from './generic-transaction'
import { TransactionsStatusBarBase } from './transactions-status-bar-base'
import { sumUnits } from './utils'

const template = `
    <div class="hs-transactions-status-bar hs-transaction-units-status-bar hs-status-bar">
      <div class="value-container">
        <label>Units:</label>
        <span id="units-container">-</span>
      </div>
    </div>
`

export class TransactionsStatusBarComp extends TransactionsStatusBarBase {
  constructor() {
    super(template)
  }

  onRowSelectionChanged = (selection: GenericTransaction[]) => {
    this.setEmpty(selection)

    const units = sumUnits(selection)

    const unitsEl = this.eGui.querySelector('#units-container')
    if (unitsEl != null) {
      unitsEl.innerHTML = `${prettyFormatNumber(units, 4)}`
    }
  }

  onSelectAllTransactions = (data?: GenericTxSummary) => {
    if (data?.units != null) {
      this.setEmpty()
      const units = data.units ?? 0
      const unitsEl = this.eGui.querySelector('#units-container')
      if (unitsEl != null) {
        unitsEl.innerHTML = `${prettyFormatNumber(units, 4)}`
      }
    }
  }
}
